(() => {
  'use strict';

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const markMakerCards = (root = document) => {
    root.querySelectorAll('.mb-author-block, .mb-illustrator-block').forEach((card) => {
      card.classList.add('mb-standard-card');
      const head = card.querySelector('.mb-author-head, .mb-illustrator-head');
      const match = normalize(head?.textContent).match(/(\d+)\s+uitgav/);
      const count = match ? Number(match[1]) : card.querySelectorAll('.mb-book-card').length;
      card.classList.toggle('mb-standard-card--multi', count > 1);
      card.classList.toggle('mb-standard-card--single', count <= 1);
    });
  };

  const markSeriesCards = (root = document) => {
    root.querySelectorAll('.mb-standard-card:not(.mb-standard-card--category)').forEach((card) => {
      const title = card.querySelector('.mb-card-head, .mb-gift-result__head, .mb-fund-list-card__copy');
      card.classList.toggle('mb-standard-card--series', /\bserie(?:s)?\b/.test(normalize(title?.textContent)));
    });
  };

  const removeEmptyFrames = (root) => {
    [...root.querySelectorAll('section, article, div, figure, p, hr')].reverse().forEach((node) => {
      if (!node.isConnected || node === root || node.closest('form')) return;
      if (node.querySelector('img, video, iframe, input, textarea, select, button, a')) return;
      if (normalize(node.textContent)) return;
      node.remove();
    });
  };

  const standardizeOrderPage = (root) => {
    if (!root || root.dataset.mbOrderSystem === 'true') return;
    const heading = root.querySelector('.mb-page-standard-title, h1, h2');
    const intro = [...root.querySelectorAll('p')].find((node) => normalize(node.textContent).includes('bestellen bij matchboox is eenvoudig en veilig'));
    const image = root.querySelector('img');
    if (!heading || !image) return;

    const hero = document.createElement('section');
    hero.className = 'mb-order-top-panel';
    const copy = document.createElement('header');
    copy.className = 'mb-order-top-copy';
    const figure = document.createElement('figure');
    const usps = document.createElement('div');
    usps.className = 'mb-standard-hero-usps';
    const uspLabels = ['Veilig betalen', 'Gratis verzending binnen Nederland', 'Track & Trace inbegrepen', 'Zorgvuldig verpakt'];
    const duplicateUsp = [...root.querySelectorAll('div, section, ul')]
      .filter((node) => {
        const value = normalize(node.textContent);
        const hits = ['veilig betalen', 'gratis verzending', 'track & trace', 'luxe cadeauverpakking', 'zorgvuldig verpakt']
          .filter((label) => value.includes(label)).length;
        return hits >= 2 && !node.closest('.mb-order-top-panel');
      })
      .sort((left, right) => left.querySelectorAll('*').length - right.querySelectorAll('*').length)[0];
    if (duplicateUsp) duplicateUsp.remove();
    uspLabels.forEach((text) => {
      const item = document.createElement('span');
      item.textContent = text;
      usps.appendChild(item);
    });

    const sourceContainer = image.closest('figure, picture');
    copy.appendChild(heading);
    if (intro) copy.appendChild(intro);
    figure.appendChild(image);
    hero.append(copy, figure, usps);
    root.prepend(hero);
    if (sourceContainer && sourceContainer !== figure && sourceContainer.isConnected && !normalize(sourceContainer.textContent) && !sourceContainer.querySelector('img')) sourceContainer.remove();
    removeEmptyFrames(root);
    root.dataset.mbOrderSystem = 'true';
  };

  const init = (root = document) => {
    markMakerCards(root);
    markSeriesCards(root);
    const orderPage = root.matches?.('.mb-page-content[data-page-handle="bestelinformatie"]')
      ? root
      : root.querySelector?.('.mb-page-content[data-page-handle="bestelinformatie"]');
    standardizeOrderPage(orderPage);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
